/* Assets/valentine-float.js */
(() => {
  const layer = document.getElementById('vf-layer');
  if (!layer) return;

  const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  if (reduced) return;

  const enabled = layer.dataset.vfEnabled !== 'false';
  if (!enabled) return;

  const start = (layer.dataset.vfStart || '').trim();
  const end = (layer.dataset.vfEnd || '').trim();
  if (!inSchedule(start, end)) return;

  window.__vfHearts = window.__vfHearts || {};
  if (window.__vfHearts.timer) clearInterval(window.__vfHearts.timer);

  layer.innerHTML = '';

  const density = clampInt(parseInt(layer.dataset.vfDensity || '50', 10), 1, 180); // por minuto
  const maxOnScreen = clampInt(parseInt(layer.dataset.vfMax || '80', 10), 5, 250);
  const burst = clampInt(parseInt(layer.dataset.vfBurst || '12', 10), 0, 80);

  const emojis = (layer.dataset.vfEmojis || '💗,❤️,💕,💖,💘')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  let onScreen = 0;

  if (burst > 0) {
    setTimeout(() => {
      for (let i = 0; i < burst; i++) {
        if (onScreen >= maxOnScreen) break;
        spawn();
      }
    }, 250);
  }

  const spawnIntervalMs = Math.max(200, Math.round(60000 / density));

  window.__vfHearts.timer = setInterval(() => {
    if (document.hidden) return;
    if (onScreen >= maxOnScreen) return;
    spawn();
  }, spawnIntervalMs);

  window.addEventListener('pagehide', () => {
    if (window.__vfHearts.timer) clearInterval(window.__vfHearts.timer);
  }, { once: true });

  function spawn() {
    const el = document.createElement('span');
    el.className = 'vf-heart';
    el.textContent = emojis[Math.floor(Math.random() * emojis.length)] || '❤️';

    const leftVw = rand(0, 100);
    const driftVw = rand(-12, 12);
    const sizePx = rand(16, 34);
    const durationMs = rand(6500, 11000);
    const rotDeg = rand(-220, 220);
    const delayMs = rand(0, 500);

    el.style.setProperty('--vf-left', `${leftVw}vw`);
    el.style.setProperty('--vf-drift', `${driftVw}vw`);
    el.style.setProperty('--vf-size', `${sizePx}px`);
    el.style.setProperty('--vf-duration', `${durationMs}ms`);
    el.style.setProperty('--vf-rot', `${rotDeg}deg`);
    el.style.setProperty('--vf-delay', `${delayMs}ms`);

    layer.appendChild(el);
    onScreen++;

    el.addEventListener('animationend', () => {
      el.remove();
      onScreen = Math.max(0, onScreen - 1);
    }, { once: true });
  }

  function inSchedule(startMMDD, endMMDD) {
    if (!startMMDD && !endMMDD) return true;

    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const today = `${mm}-${dd}`;

    if (startMMDD && endMMDD) return today >= startMMDD && today <= endMMDD;
    if (startMMDD) return today >= startMMDD;
    return today <= endMMDD;
  }

  function rand(min, max) { return Math.random() * (max - min) + min; }

  function clampInt(n, min, max) {
    if (Number.isNaN(n)) return min;
    return Math.min(max, Math.max(min, n));
  }
})();
